import {
  REQUEST_INITIAL,
  REQUEST_SUCCESS,
  REQUEST_INPROGRESS,
  REQUEST_ERROR,
} from 'store/constants';

import {
  FANCY_NUMBERS_SET,
  FANCY_NUMBERS_SET_ACTIVE,
  TOGGLE_FANCYNUMBER,
  FANCY_NUMBERS_REQUEST,
  FANCY_NUMBERS_FAIL,
} from './constants';

const initialState = {
  fancyNumbers: [],
  fancyNumbersIndex: 0,
  fancyNumbersStatus: REQUEST_INITIAL,
  toggleFancyNumber: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FANCY_NUMBERS_REQUEST: {
      return {
        ...state,
        fancyNumbersStatus: REQUEST_INPROGRESS,
      };
    }
    case FANCY_NUMBERS_SET: {
      return {
        ...state,
        fancyNumbersStatus: REQUEST_SUCCESS,
        fancyNumbers: action.payload,
      };
    }
    case FANCY_NUMBERS_FAIL: {
      return {
        ...state,
        fancyNumbersStatus: REQUEST_ERROR,
      };
    }
    case FANCY_NUMBERS_SET_ACTIVE: {
      return {
        ...state,
        fancyNumbersIndex: action.payload,
      };
    }
    case TOGGLE_FANCYNUMBER: {
      return {
        ...state,
        toggleFancyNumber: action.payload,
      };
    }
    default:
      return state;
  }
}
